import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Select from '../form/Select'
import Input from '../form/Input'

import './styles/skipNumericOption.scss'

@observer
class SkipNumericOption extends Component {
    quotaOptions = [
        {
            value: 'Gt',
            label: 'Is greater than',
        },
        {
            value: 'Eq',
            label: 'Is equal to',
        },
        {
            value: 'Lt',
            label: 'Is less than',
        },
    ]

    findQuestion(trigger) {
        const { store } = this.props
        const { survey, skipLogicConfig } = store
        const pageQuestions = survey.pages.reduce((questions, page, index) => {
            if (page.pageType === 'ST' && index <= skipLogicConfig.pageIndex) {
                questions = questions.concat(page.questions.slice())
                console.log(page.questions)
            }
            return questions
        }, [])

        let parentQuestion = null
        const pq = pageQuestions.find(pq => pq.id.toLowerCase() === (trigger.condition.pageQuestionId ? trigger.condition.pageQuestionId.toLowerCase() : null))
        this.question = pq ? pq.question : undefined
        if (pq && pq.parentId) {
            parentQuestion = pageQuestions.find(pageQuestion => pageQuestion.id.toLowerCase() === pq.parentId.toLowerCase())
        }
        this.parentQuestion = parentQuestion ? parentQuestion.question : undefined
    }

    getLabel = () => {
        const { store } = this.props
        return this.question
            ? this.question.content.getTitleByLocale('shortTitle', store.surveyLocale, store.survey.metadata.defaultLocale)
            : 'Question not found -- remove'
    }

    getOptionLabel = (condition) => {
        const { store } = this.props
        console.log(this.question)
        const { options } = this.question.optionSet
        let option = options.find(option => option.id.toLowerCase() === condition.set1.toLowerCase())

        return option.getTitle(store.surveyLocale, store.survey.metadata.defaultLocale, this.question.metadata.initialLocale)
    }

    updateQuota = (e) => {
        const { group, triggerIndex } = this.props
        const { condition } = group.triggers[triggerIndex]
        const value = parseInt(e.value, 10)

        condition.value = value
    }

    updateOperator = (obj) => {
        const { group, triggerIndex } = this.props
        const { condition } = group.triggers[triggerIndex]

        condition.equalityOperator = obj.value
    }

    render() {
        const {
            group, triggerIndex, index, question, store,
        } = this.props
        const { condition } = group.triggers[triggerIndex]
        const { value, equalityOperator } = condition

        this.findQuestion(group.triggers[triggerIndex])
        const { questionTypeCode } = this.question

        return (
            <div className={`skip-date-option-wrapper ${triggerIndex === 0 ? 'option-wrapper-border-radius' : ''}`}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 20, alignItems: 'center' }}>
                    <Select
                        cssClass="skipLogicDropdown"
                        label={i18n.t('skipLogicModal.pageLogicRuleAnswer')}
                        defaultValue={this.quotaOptions
                            .find(({ value }) => value === equalityOperator).value}
                        onBlur={this.updateOperator}
                        options={this.quotaOptions}
                        style={{
                            width: '100%',
                        }}
                    />

                    <Input
                        type="number"
                        label="Value"
                        cssClass="skipLogicNumberInput"
                        min={0}
                        step={1}
                        defaultValue={value}
                        placeholder={i18n.t('form.input.placeholder')}
                        onChange={this.updateQuota}
                        onBlur={this.updateQuota}
                    />
                </div>

                <br />

                <div style={{ width: '100%', fontSize: 12 }}>
                    {this.getLabel()}
                </div>

                <div className="skip-options-container">
                    <div className="skip-option-label">
                        {questionTypeCode === 'I'
                            ? this.getLabel()
                            : `${this.getLabel()} - ${this.getOptionLabel(condition)}`}

                        <i
                            className="fal fa-times-circle deleteicon"
                            onClick={(e) => {
                                question.removeTrigger(index, e)
                                store.handleUnsavedSkipLogicChanges()
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default SkipNumericOption
